/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Continue_As_Chat_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not continue this run as a chat. Please try again." |
*
* @param {Agent_Run_Continue_As_Chat_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_continue_as_chat_error = /** @type {((inputs?: Agent_Run_Continue_As_Chat_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Continue_As_Chat_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Lauf konnte nicht als Chat fortgesetzt werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Could not continue this run as a chat. Please try again.")
});